import React, { useEffect } from 'react'
import * as clinicianTracking from '@lib/clinician-tracking'

export function useComponentRenderTracker(eventName: string) {
  useEffect(() => {
    clinicianTracking.trackEvent(eventName)
  }, [])
}
